import React from "react";
import ProjectActions from "../../Project/NavbarActions";
import type { Project } from "../../../api/useProjects";

interface P {
  project: Project;
}

const AppHeaderActions = ({ project }: P) => (
  <React.Suspense key={project.id}>
    <ProjectActions project={project} />
  </React.Suspense>
);

export default AppHeaderActions;
